import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useInstallationContext } from '../../../context/installation';
import { UserGroup } from '../../../data-access/gql-types/graphql';
import { ROUTES } from '../../../routes/routes';
import { SharedItemType } from '../../../types';
import { toastError } from '../../../utils/toast';
import { ChannelType } from '../../../integrations/lavva/types';
import { initialState, StateShareInstallationType } from '../context';

export const useShareRedirect = () => {
  const navigate = useNavigate();
  const { t: tc } = useTranslation('common');
  const { selectedInstallationId } = useInstallationContext();

  const shareInstallation = (installationId?: string) => {
    if (installationId) {
      const state: StateShareInstallationType = {
        ...initialState,
        installationId,
      };

      navigate(`${ROUTES.InstallationShared(installationId)}?state=${JSON.stringify(state)}`);
    } else {
      toastError({ content: tc('errors.somethingWentWrong') });
    }
  };

  const shareChannel = (channel?: ChannelType) => {
    if (channel) {
      const state: StateShareInstallationType = {
        ...initialState,
        installationId: selectedInstallationId || '',
        shareItem: { itemId: channel.id, name: channel.alias },
        channels: [{ id: channel.id, name: channel.alias }],
        subject: SharedItemType.Channel,
      };

      navigate(`${ROUTES.InstallationShared(selectedInstallationId)}?state=${JSON.stringify(state)}`);
    } else {
      toastError({ content: tc('errors.somethingWentWrong') });
    }
  };

  const shareGroup = (userGroup?: UserGroup) => {
    if (userGroup) {
      const state: StateShareInstallationType = {
        ...initialState,
        installationId: selectedInstallationId || '',
        shareItem: { itemId: userGroup.id, name: userGroup.group.name },
        channels: [{ id: userGroup.id, name: userGroup.group.name }],
        subject: SharedItemType.Group,
      };

      navigate(`${ROUTES.InstallationShared(selectedInstallationId)}?state=${JSON.stringify(state)}`);
    } else {
      toastError({ content: tc('errors.somethingWentWrong') });
    }
  };

  return {
    shareInstallation,
    shareChannel,
    shareGroup,
  };
};
